export default "__VITE_ASSET__e13ee0cd__"